import Vue from 'vue'

export default class OutputBuffer {
    constructor (terminalBus, finishCallback) {
        this.buffer = ''
        this.finishCallback = finishCallback
        this.buffering = false

        terminalBus.$on('writeOutput', output => {
            if (!this.buffering) {
                this.buffering = true
                Vue.nextTick(() => this.finishOutput())
            }

            this.buffer += output
        })
    }

    finishOutput () {
        this.finishCallback(this.buffer)
        this.buffer = ''
        this.buffering = false
    }
}
